// Enums to use in the componets
export enum AccountLicenseEnum {
  Forex = 0,
  Viop = 1,
  CTrade = 2,
  Option = 3,
  SingleStocks = 4,
}
